export default function stickyCta() {
  try {
    if (sessionStorage.getItem('sticky-cta-dismissed') === '1') return;
  } catch (e) {
    // sessionStorage blocked (private browsing, strict cookie policies)
  }

  const bar = document.querySelector('.sticky-cta');
  if (!bar) return;

  if (!('IntersectionObserver' in window)) return;

  const path = window.location.pathname;
  const suppressed = ['/work-with-mamta/', '/contact/', '/subscribe/'];
  if (suppressed.includes(path)) return;

  const heroEl = document.querySelector('.home-hero')
    || document.querySelector('.gh-article-image')
    || document.querySelector('.gh-article')
    || document.querySelector('main');

  if (!heroEl) return;

  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) {
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  }, { threshold: 0 });

  observer.observe(heroEl);

  const dismissBtn = bar.querySelector('.sticky-cta-dismiss');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', () => {
      bar.classList.remove('visible');
      try {
        sessionStorage.setItem('sticky-cta-dismissed', '1');
      } catch (e) {
        // sessionStorage blocked
      }
      observer.disconnect();
    });
  }
}
